import Cookies from "js-cookie";
import { removeFromLocalStorage } from "utils/localStorage/localStorage.utils";

const tokenname = "access_token";
const cookieOptions = {
  path: "/",
  secure: true,
  sameSite: "strict" as const,
};
export const removeUserStoredData = (path: string = "/") => {
  Cookies.remove(tokenname, { ...cookieOptions, path: path });
  removeFromLocalStorage("user");
  removeFromLocalStorage("userPermissions");
  console.log("User stored data removed from cookies and localStorage.");
};

export const hasValidToken = (): boolean => {
  const token = Cookies.get(tokenname);
  console.log(token !== null && token !== undefined ? "Toke Alive!" : "Missing token")
  const wasRemoved = token === undefined;
  console.log(`Token removed: ${wasRemoved}`, { token });
  return !wasRemoved;
};
